(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alman-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alman-product-information')) {
    customElements.define('alman-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.handleInformationClick = event => {
          let trigger = event.target.closest('[data-panel]');
          const summary = event.target.closest("[data-testid='product-information'] .accordion summary");
          if (summary) {
            const title = summary.textContent.trim().toLocaleLowerCase('pt-BR');
            const panel = title.includes('detalhes do produto') || title.includes('composição') ? 'composition' : title.includes('pagamento') ? 'payment' : title.includes('devoluções') ? 'shipping' : null;
            if (panel) { event.preventDefault(); summary.dataset.panel = panel; trigger = summary; }
          }
          if (trigger) {
            event.preventDefault();
            this.opener = trigger;
            const dialog = this.querySelector(`[data-information-panel="${trigger.dataset.panel}"]`);
            dialog.showModal();
            document.documentElement.setAttribute('scroll-lock', '');
          }
          if (event.target.closest('[data-close]')) event.target.closest('dialog').close();
          if (event.target instanceof HTMLDialogElement) {
            const bounds = event.target.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right) event.target.close();
          }
        };
        document.addEventListener('click', this.handleInformationClick);
        this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
          document.documentElement.removeAttribute('scroll-lock');
          this.opener?.focus();
        }));
      }
      disconnectedCallback() { document.removeEventListener('click', this.handleInformationClick); this.initialized = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
